import React, { Component } from 'react';
import { HorizontalBar } from 'react-chartjs-2';
import { Query } from '@apollo/client/react/components';
import { GET_CHART_DATA } from '../api';
import { Loader } from '../../../components/Loader';
import { ToggleButton, ToggleButtonGroup } from 'react-bootstrap';

class BarChart extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      sortOrder: props.orderVal,
      sortType: props.defaultSortType,
      source: props.source,
    };
  }

  toggleSort = () => {
    this.setState({ sortOrder: 3 - this.state.sortOrder });
  };

  updateSortType = (event: any) => {
    this.setState({ sortType: event.target.value });
  };

  orderFilter = (deps: any) => {
    if (this.props.orderVal === 1) {
      return deps.sort((a: any, b: any) => (a.total > b.total ? 1 : -1));
    } else {
      return deps.sort((a: any, b: any) => (a.total < b.total ? 1 : -1));
    }
  };

  sortData = (data: any, sortOrder: any, sortType: any) => {
    if (sortType === 'percent') {
      if (sortOrder === 1) return [...data].sort((a: any, b: any) => (a.percentDone > b.percentDone ? 1 : -1));
      else return [...data].sort((a: any, b: any) => (a.percentDone < b.percentDone ? 1 : -1));
    } else if (sortType === 'total') {
      if (sortOrder === 1) return [...data].sort((a: any, b: any) => (a.total > b.total ? 1 : -1));
      else return [...data].sort((a: any, b: any) => (a.total < b.total ? 1 : -1));
    } else if (sortType === 'scanned') {
      if (sortOrder === 1) return [...data].sort((a: any, b: any) => (a.scanned > b.scanned ? 1 : -1));
      else return [...data].sort((a: any, b: any) => (a.scanned < b.scanned ? 1 : -1));
    } else if (sortType === 'name') {
      if (sortOrder === 1) return [...data].sort((a: any, b: any) => (a.name > b.name ? 1 : -1));
      else return [...data].sort((a: any, b: any) => (a.name < b.name ? 1 : -1));
    } else {
      if (sortOrder === 1) return [...data].sort((a: any, b: any) => (a.name > b.name ? 1 : -1));
      else return [...data].sort((a: any, b: any) => (a.name < b.name ? 1 : -1));
    }
  };

  render() {
    return (
      <Query
        query={GET_CHART_DATA}
        variables={{
          assetFilter: {
            assetTableEntry: true,
            isDeleted: false,
            source: this.state.source,
            // Year: `${new Date().getFullYear()-1}`,
          },
        }}
        fetchPolicy='cache-and-network'>
        {({ loading, error, data }: any) => {
          if (loading) return <Loader />;
          if (error) return <div>error</div>;
          let chartData = this.sortData(data.chartData, this.state.sortOrder, this.state.sortType);

          let labels = chartData.map((element: { name: string; percentDone: string; abbreviation: string }) => {
            return element.name + ' ' + element.percentDone + '% ' + element.abbreviation;
          });
          let scanned = chartData.map((element: { total: number; needScan: number }) => {
            return element.total - element.needScan;
          });
          let unscanned = chartData.map((element: { needScan: any }) => {
            return element.needScan;
          });

          return (
            <div>
              <div className='float-right'>
                <label htmlFor='sortType'>Sort by </label>
                <select name='sortType' onChange={this.updateSortType.bind(this)} value={this.state.sortType}>
                  <option value='total'>Total Number of Items</option>
                  <option value='scanned'>Number Scanned Items</option>
                  <option value='percent'>Percent Complete</option>
                  <option value='name'>Department Name</option>
                </select>
                <ToggleButtonGroup
                  name='barChartSort'
                  type='checkbox'
                  value={this.state.sortOrder}
                  onChange={this.toggleSort.bind(this)}
                  className='padding-2'>
                  <ToggleButton variant='light' value={1}>
                    <i className='fas fa-arrow-alt-circle-up' />
                  </ToggleButton>
                  <ToggleButton variant='light' value={2}>
                    <i className='fas fa-arrow-alt-circle-down' />
                  </ToggleButton>
                </ToggleButtonGroup>
              </div>

              <HorizontalBar
                data={{
                  labels: labels,
                  datasets: [
                    {
                      label: 'Scanned',
                      backgroundColor: '#00bc8c',
                      data: scanned,
                    },
                    {
                      label: 'Unscanned',
                      backgroundColor: '#F39C12',
                      data: unscanned,
                    },
                  ],
                }}
                options={{
                  maintainAspectRatio: true,
                  responsive: true,
                  legend: { display: true },
                  scales: {
                    yAxes: [{ stacked: true }],
                    xAxes: [{ stacked: true }],
                    categoryPercentage: 1,
                  },
                }}
              />
            </div>
          );
        }}
      </Query>
    );
  }
}

export default BarChart;
